import React from 'react';
import { SUPPORT_EMAIL } from 'config/constants';

const LinkToAdminBlock = ({ reasonText }) => (
  <div style={{ maxWidth: '550px' }}>
    {reasonText || ''} Please, contact administrator{' '}
    <a className="form-link fs-12" href={`mailto:${SUPPORT_EMAIL}`}>
      {SUPPORT_EMAIL}
    </a>{' '}
    for more details.
  </div>
);

export default LinkToAdminBlock;
